import { Injectable } from "@angular/core";
import { createFrom, EventService } from "@spartacus/core";
import { filter, map, Observable, switchMap, take } from "rxjs";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { GonvarriUser } from "src/app/core/models/gonvarri-user.model";
import { NavigationEvent } from "@spartacus/storefront";
import { GonvarriQuickStockNavigationEvent } from "./gonvarri-navigation.events";


@Injectable({ providedIn: 'root' })
export class GonvarriNavigationEventBuilder {

  constructor(
      protected event: EventService,
      protected userAccountFacade: UserAccountFacade,
  ) {
    this.register();
  }

  protected register(): void {
    this.event.register(
      GonvarriQuickStockNavigationEvent,
      this.buildQuickStockNavigationEvent()
    );
  }

  protected buildQuickStockNavigationEvent(): Observable<GonvarriQuickStockNavigationEvent> {
    return this.event.get(NavigationEvent).pipe(
      filter(event => event.url.includes('quick-stock-page')), // Filter the Navigation event to get it only when the user navigates to the quick stock page
      switchMap(() => this.userAccountFacade.get().pipe( // Get the user details
        filter(user => !!user),
        take(1),
        map(user => createFrom(GonvarriQuickStockNavigationEvent, { // Here we are mapping the user details to the custom event matching the same GTM tag used by accelerator.
          user_id: (user as GonvarriUser).orgUnit?.uid ?? '',
          user_email: user?.uid ?? '',
        }))
      ))
    );
  }

}
